import { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import homeFill from '@iconify/icons-eva/home-fill';
import fileFill from '@iconify/icons-eva/file-fill';
import roundGrain from '@iconify/icons-ic/round-grain';
import bookOpenFill from '@iconify/icons-eva/book-open-fill';

import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import AlarmIcon from '@mui/icons-material/LoginSharp';

import { Box, Button, AppBar, Toolbar, Container, Grid } from '@mui/material';
// hooks
import useOffSetTop from '../../hooks/useOffSetTop';

// components
import Logo from '../../components/Logo';
import Label from '../../components/Label';
import { MHidden } from '../../components/@material-extend';
import { PATH_PAGE, PATH_AUTH } from '../../routes/paths';
import { useDispatch, useSelector } from '../../redux/store';
import { getcountJaminan } from '../../redux/slices/lelang';

//
import MenuDesktop from './MenuDesktop';
import MenuMobile from './MenuMobile';
import AccountPopover from '../dashboard/AccountPopover';
import useAuth from '../../hooks/useAuth';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 85;

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  height: APP_BAR_MOBILE,
  transition: theme.transitions.create(['height', 'background-color'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  [theme.breakpoints.up('md')]: {
    height: APP_BAR_DESKTOP,
    marginTop: -10,
    marginBottom: 5
  }
}));

const ToolbarShadowStyle = styled('div')(({ theme }) => ({
  left: 0,
  right: 0,
  bottom: 0,
  height: 24,
  zIndex: -1,
  margin: 'auto',
  borderRadius: '50%',
  position: 'absolute',
  width: `calc(100% - 48px)`,
  boxShadow: theme.customShadows.z8
}));

const ICON_SIZE = {
  width: 22,
  height: 22
};

// ----------------------------------------------------------------------

export default function MainNavbar() {
  const isOffset = useOffSetTop(100);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  const linkToLike = `${PATH_PAGE.login}`;

  const { isAuthenticated } = useAuth();
  const handleMinat = () => {
    navigate(linkToLike);
  };

  const dispatch = useDispatch();
  const { countjaminan } = useSelector((state) => state.lelang);

  useEffect(() => {
    dispatch(getcountJaminan());
  }, [dispatch]);

  console.log(JSON.stringify(countjaminan));
  const stabilizedThis = countjaminan.map((el, index) => ({
    title: countjaminan[index].split(',')[0],
    path: `${PATH_PAGE.lelang}/${countjaminan[index].split(',')[0]}`,
    count: countjaminan[index].split(',')[1]
  }));
  console.log(JSON.stringify(stabilizedThis));

  const menuConfig = [
    {
      title: 'Beranda',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/'
    },
    {
      title: 'Daftar Aset',
      path: PATH_PAGE.lelang,
      icon: <Icon icon={fileFill} {...ICON_SIZE} />,
      children: [
        {
          subheader: 'Kategori Aset',
          items: stabilizedThis
        },
        {
          subheader: 'Semua',
          items: [{ title: 'Semua', path: PATH_PAGE.lelang }]
        }
      ]
    },
    {
      title: 'Jadwal Lelang',
      icon: <Icon icon={roundGrain} {...ICON_SIZE} />,
      path: PATH_PAGE.list
    },
    {
      title: 'Prosedur',
      icon: <Icon icon={roundGrain} {...ICON_SIZE} />,
      path: PATH_PAGE.prosedur
    },
    {
      title: 'FAQ',
      icon: <Icon icon={roundGrain} {...ICON_SIZE} />,
      path: PATH_PAGE.faqs
    }
  ];

  return (
    <AppBar sx={{ boxShadow: 0, bgcolor: 'white' }}>
      <ToolbarStyle
        disableGutters
        sx={{
          ...(isOffset && {
            bgcolor: 'background.default',
            height: { md: APP_BAR_DESKTOP - 14 }
          })
        }}
      >
        <Container
          maxWidth="false"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: { md: 5 }
          }}
          md={11}
        >
          <RouterLink to="/">
            <Logo />
          </RouterLink>
          <Box sx={{ flexGrow: 1 }} />

          <MHidden width="mdDown">
            <MenuDesktop isOffset={isOffset} isHome={isHome} navConfig={menuConfig} />
            {isAuthenticated && <AccountPopover />}
            {!isAuthenticated && (
              <Button onClick={handleMinat} startIcon={<AlarmIcon />} variant="contained">
                Masuk
              </Button>
            )}
          </MHidden>

          <MHidden width="mdUp">
            <MenuMobile isOffset={isOffset} isHome={isHome} navConfig={menuConfig} />
            {isAuthenticated && <AccountPopover />}
            {!isAuthenticated && (
              <Button sx={{ width: '20%' }} onClick={handleMinat} startIcon={<AlarmIcon />} variant="contained">
                Masuk
              </Button>
            )}
          </MHidden>
        </Container>
      </ToolbarStyle>

      {isOffset && <ToolbarShadowStyle />}
    </AppBar>
  );
}
